var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lawForm"},[_c('div',{staticClass:"title"},[_vm._v("关于我们")]),_c('div',{staticClass:"contet",domProps:{"innerHTML":_vm._s(_vm.about)}})])}
var staticRenderFns = []

export { render, staticRenderFns }